// Copyright (c) 2016 Deere & Company

import PipDetails from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.pips.details,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;
    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipDetails);



// WEBPACK FOOTER //
// ./src/pip/pip-details/state-connector.js